module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visatype) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel outer-panel"
  }, [_c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === -2
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = -2
      }
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === -1
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = -1
      }
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), _vm._l((_vm.visatype.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDocs = false;
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "tab-item tab-action"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSectionName),
      expression: "newSectionName"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "New section"
    },
    domProps: {
      "value": (_vm.newSectionName)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSection($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSectionName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm input-group-btn",
    on: {
      "click": _vm.addSection
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-inline"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveType
    }
  }, [_vm._v("Save")])])])], 2)]), _vm._v(" "), (_vm.secKey === -2) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visatype.info),
      expression: "visatype.info"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "HTML",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.visatype.info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.visatype, "info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visatype.checklist_id),
      expression: "visatype.checklist_id"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.visatype.checklist_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.visatype, "checklist_id", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.secKey === -1) ? _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.visatype.doctypes || !_vm.visatype.doctypes.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h5', {
    staticClass: "empty-title"
  }, [_vm._v("There are no documents for this matter type")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.showDocModal = true
      }
    }
  }, [_vm._v("Make a document type")])])]) : _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Help text")]), _vm._v(" "), _c('th', [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showDocModal = true
      }
    }
  }, [_vm._v("New")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visatype.doctypes), function(d, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(d.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(d.helptext))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.openEditDoc(d, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.delDoc(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveDoc(i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveDoc(i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-up"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.secKey >= 0) ? _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.visatype.sections.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("There are no sections for this matter type")])]) : (!_vm.visatype.sections[_vm.secKey].subsections.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("No subsections")])]) : _vm._l((_vm.visatype.sections[_vm.secKey].subsections), function(sub, subKey) {
    return _c('div', {
      staticClass: "panel subPanel"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title",
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('p', {
      staticStyle: {
        "margin": "0"
      }
    }, [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-clear",
      on: {
        "click": function($event) {
          return _vm.delSubsection(subKey)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "subControls"
    }, [_c('label', {
      staticClass: "form-checkbox",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v("Repeatable\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sub.repeatable),
        expression: "sub.repeatable"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(sub.repeatable) ? _vm._i(sub.repeatable, null) > -1 : (sub.repeatable)
      },
      on: {
        "change": function($event) {
          var $$a = sub.repeatable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(sub, "repeatable", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(sub, "repeatable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(sub, "repeatable", $$c)
          }
        }
      }
    }), _c('i', {
      staticClass: "form-icon"
    })]), _vm._v(" |\n            "), _c('label', {
      staticClass: "form-checkbox",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v("For Client\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sub.for_client),
        expression: "sub.for_client"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(sub.for_client) ? _vm._i(sub.for_client, null) > -1 : (sub.for_client)
      },
      on: {
        "change": function($event) {
          var $$a = sub.for_client,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(sub, "for_client", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(sub, "for_client", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(sub, "for_client", $$c)
          }
        }
      }
    }), _c('i', {
      staticClass: "form-icon"
    })]), _vm._v(" |\n            "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openDeps(sub, subKey)
        }
      }
    }, [_vm._v("Deps")]), _vm._v(" |\n            "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveSub(subKey, 1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm",
      on: {
        "click": function($event) {
          return _vm.moveSub(subKey, -1)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-up"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [(!sub.questions.length) ? _c('div', {
      staticClass: "empty"
    }, [_c('h4', {
      staticClass: "empty-title"
    }, [_vm._v("No questions")]), _vm._v(" "), _c('div', {
      staticClass: "empty-action"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.openNewQ(subKey, 0)
        }
      }
    }, [_vm._v("Add a question")])])]) : _c('table', {
      staticClass: "table table-striped"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((sub.questions), function(q, qKey) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "30%"
        }
      }, [_vm._v(_vm._s(q.text))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "40%"
        }
      }, [_vm._v(_vm._s(q.helptext))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(q.type))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right",
          "width": "25%"
        }
      }, [_c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.openEditQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.delQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o",
        attrs: {
          "aria-hidden": "true"
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.openNewQ(subKey, qKey)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.moveQ(subKey, qKey, 1)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-arrow-down"
      })]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-sm",
        on: {
          "click": function($event) {
            return _vm.moveQ(subKey, qKey, -1)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-arrow-up"
      })])])])
    }), 0)])])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.secKey >= 0) ? _c('div', {
    staticClass: "panel-footer"
  }, [(_vm.visatype.sections.length) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSubName),
      expression: "newSubName"
    }],
    staticClass: "form-input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "New subsection"
    },
    domProps: {
      "value": (_vm.newSubName)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSubsection($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSubName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary input-group-btn btn-sm",
    on: {
      "click": _vm.addSubsection
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('button', {
    staticClass: "btn btn-sm float-right",
    on: {
      "click": _vm.delSection
    }
  }, [_vm._v("Delete section")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showQModal
    },
    attrs: {
      "id": "editQ"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": _vm.closeQ
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.editingQ ? 'Edit question' : 'New question'))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.type),
      expression: "tempQ.type"
    }],
    staticClass: "form-select",
    attrs: {
      "id": "editqtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempQ, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yn"
    }
  }, [_vm._v("Y/N")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "number"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "textarea"
    }
  }, [_vm._v("Text area")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "language"
    }
  }, [_vm._v("Language")])])])]), _vm._v(" "), (_vm.tempQ.type === 'select') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectInput),
      expression: "selectInput"
    }],
    staticClass: "form-input",
    attrs: {
      "id": "editqtxt",
      "placeholder": "<display>, <value>"
    },
    domProps: {
      "value": (_vm.selectInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectInput = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.text),
      expression: "tempQ.text"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "editqtxt",
      "placeholder": "Question text"
    },
    domProps: {
      "value": (_vm.tempQ.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempQ, "text", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.helptext),
      expression: "tempQ.helptext"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "editqhelptxt",
      "placeholder": "Help text"
    },
    domProps: {
      "value": (_vm.tempQ.helptext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempQ, "helptext", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.dependent),
      expression: "tempQ.dependent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempQ.dependent) ? _vm._i(_vm.tempQ.dependent, null) > -1 : (_vm.tempQ.dependent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempQ.dependent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempQ, "dependent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempQ, "dependent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempQ, "dependent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (_vm.tempQ.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.ref),
      expression: "tempQ.depends.ref"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempQ.depends, "ref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tempQ.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.atxt),
      expression: "tempQ.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.tempQ.depends.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempQ.depends, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempQ.depends.atxt),
      expression: "tempQ.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.tempQ.depends.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempQ.depends, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editingQ) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editQ
    }
  }, [_vm._v("Done")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addQ
    }
  }, [_vm._v("Save")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDocModal
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": _vm.closeQ
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Edit document type")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.name),
      expression: "tempDoc.name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tempDoc.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempDoc, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.helptext),
      expression: "tempDoc.helptext"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.tempDoc.helptext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempDoc, "helptext", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.dependent),
      expression: "tempDoc.dependent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tempDoc.dependent) ? _vm._i(_vm.tempDoc.dependent, null) > -1 : (_vm.tempDoc.dependent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempDoc.dependent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempDoc, "dependent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempDoc, "dependent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempDoc, "dependent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  })])])]), _vm._v(" "), (_vm.tempDoc.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.ref),
      expression: "tempDoc.depends.ref"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempDoc.depends, "ref", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.tempDoc.dependent) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.atxt),
      expression: "tempDoc.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.tempDoc.depends.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempDoc.depends, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempDoc.depends.atxt),
      expression: "tempDoc.depends.atxt"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.tempDoc.depends.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tempDoc.depends, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [(_vm.editingDoc) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeQ
    }
  }, [_vm._v("Done")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addDoc
    }
  }, [_vm._v("Save")])])])])])])])]), _vm._v(" "), (_vm.visatype && _vm.subKey > -1) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showDepsModal
    },
    attrs: {
      "id": "editDeps"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": function($event) {
        _vm.showDepsModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Dependencies")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depRef),
      expression: "depRef"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.depRef = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Choose a question")]), _vm._v(" "), _vm._l((_vm.boolQuestions), function(q) {
    return _c('option', {
      domProps: {
        "value": q.ref
      }
    }, [_vm._v(_vm._s(q.text))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depVal),
      expression: "depVal"
    }],
    attrs: {
      "type": "radio",
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.depVal, "y")
    },
    on: {
      "change": function($event) {
        _vm.depVal = "y"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("Yes\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depVal),
      expression: "depVal"
    }],
    attrs: {
      "type": "radio",
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.depVal, "n")
    },
    on: {
      "change": function($event) {
        _vm.depVal = "n"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v("No\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addDep($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetDep
    }
  }, [_vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        _vm.showDepsModal = false
      }
    }
  }, [_vm._v("Close")])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Matter Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Checklist ID")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Question")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Help text")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtype"
    }
  }, [_vm._v("Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtxt"
    }
  }, [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqhelptxt"
    }
  }, [_vm._v("Help text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Conditional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Help text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Conditional?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Display if")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("is")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b64466e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/visatypes/visatype.vue
// module id = 516
// module chunks = 1